import './Layer.css';

function Layer(){
    return(
        <div className='page-layer'>
            <img src="/assets/imagenes/SEO/logo-principal.jpg" alt="Dormihogar logo"/>
        </div>
    )
}

export default Layer;
